import styled from "styled-components";
import { Icon as SurIcon } from "semantic-ui-react";
import useNoteModel from "@agp/shared.user-app/application/model/note";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";

const NotePage = () => {
  const model = useNoteModel();
  return (
    <AnimatedPageTransition>
      <Wrapper onClick={model.onClick}>
        {model.texts.map((x, i) => (
          <Segment key={i}>
            <Icon name="circle" size="large" />
            <Text>{x}</Text>
          </Segment>
        ))}
      </Wrapper>
    </AnimatedPageTransition>
  );
};

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Segment = styled.div`
  margin: 20px 10px;
  display: flex;
  gap: 5px;
`;

const Icon = styled(SurIcon)`
  line-height: 32px !important;
`;

const Text = styled.div`
  font-size: 20px;
  display: inline-block;
  line-height: 32px;
`;

export default NotePage;
